<template>
  <div class="md:block h-full min-h-36 bg-white pb-16">
    <h1 class="text-center pt-10 pb-16 text-gray-800 text-4xl font-extrabold">
      Our Partner Physicians
    </h1>

    <!-- Center wrapper with responsive padding -->
    <div class="flex justify-center items-center px-4">
      <ul
        class="grid grid-cols-1 sm:grid-cols-2 gap-6 mx-4 sm:mx-10 md:mx-36 w-full max-w-5xl"
      >
        <li
          class="flex p-6 items-center justify-center flex-col gap-2 text-center border border-gray-200 rounded-xl hover:bg-orange-50 transition"
          v-for="(item, index) in itemHowItsWork"
          :key="index"
        >
          <span>
            <img
              class="w-24 h-24 md:w-28 md:h-28 object-cover rounded-full shadow"
              :src="require(`@/assets/images/${item.profile}`)"
              alt=""
            />
          </span>

          <div>
            <h2 class="text-orange-600 font-semibold text-lg">
              {{ item.name }}
            </h2>
            <p class="text-base text-black/80 font-medium">
              {{ item.specialization }}
            </p>
          </div>

          <div class="grid grid-cols-1 gap-3 mt-3">
            <div>
              <p class="text-xs text-gray-600">Today Schedule</p>
              <p class="text-sm">{{ item.schedule }}</p>
            </div>

            <div
              v-show="false"
              class="text-sm flex items-center justify-center bg-primary border border-orange-400 text-white px-16 min-h-12 rounded-md hover:bg-orange-50 hover:text-orange-600 transition"
            >
              Profile
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const itemHowItsWork = ref([
      {
        id: 1,
        profile: "doc-lee.jpeg",
        name: "Dr. Leandro Lee Uyguanco",
        specialization: "General Medicine / Ophthalmology",
        schedule: "8:00AM - 8:00PM",
      },
      {
        id: 2,
        profile: "melanie.jpg",
        name: "Dr. Melanie Martinez",
        specialization: "General Practitioner",
        schedule: "08:00AM - 08:00PM",
      },
    ]);

    return { itemHowItsWork };
  },
};
</script>
